import React from 'react';
import { motion } from 'framer-motion';

const NotFound = () => {
  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      className="min-h-screen bg-gray-50 flex items-center justify-center"
    >
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-8">Página no encontrada</p>
        <p className="text-gray-500">
          La página que buscas no existe. Regresa al inicio.
        </p>
      </div>
    </motion.div>
  );
};

export default NotFound;